import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

import { CssVariablesService } from '@shared/services/css-variables.service';
import { Subject, takeUntil } from 'rxjs';

@Directive({
  selector: 's[strikeColor]',
  standalone: true,
})
export class SStrikeColorDirective implements OnChanges, OnDestroy {
  @Input() strikeColor = 'inherit';

  private ngUnsubscribe$ = new Subject<void>();

  constructor(
    private el: ElementRef,
    private cssVariables: CssVariablesService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.ngUnsubscribe$.next();
    this.cssVariables
      .getRootCssVariableAccordingToCurrentVI(
        this.strikeColor,
        this.strikeColor
      )
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((color) => {
        this.el.nativeElement.style.textDecorationColor = color;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
